import { Clock, BarChart, Globe } from 'lucide-react';

const FigmaIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z" />
    <path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z" />
    <path d="M8.5 16H12v-7H8.5a3.5 3.5 0 1 0 0 7z" />
    <path d="M5 18.5A3.5 3.5 0 0 1 8.5 15H12v4.5A3.5 3.5 0 1 1 8.5 15z" />
    <path d="M12 9h3.5a3.5 3.5 0 1 1 0 7H12V9z" />
  </svg>
);

export default function CourseStats() {
  const stats = [
    {
      icon: <Clock className="w-8 h-8 text-primary-600 dark:text-primary-500" />,
      title: "المدة",
      desc: "4 أسابيع (16–20 ساعة تدريبية + تطبيق)."
    },
    {
      icon: <BarChart className="w-8 h-8 text-primary-600 dark:text-primary-500" />,
      title: "المستوى",
      desc: "متوسط (يتطلب معرفة مسبقة بـ Illustrator)."
    },
    {
      icon: <Globe className="w-8 h-8 text-primary-600 dark:text-primary-500" />,
      title: "النمط",
      desc: "أونلاين – تطبيق + مشروع عميل محاكى."
    },
    {
      icon: <FigmaIcon className="w-8 h-8 text-primary-600 dark:text-primary-500" />,
      title: "الأدوات",
      desc: "Illustrator (أساسي) + Photoshop (Mockups)."
    }
  ];

  return (
    <section className="py-16 relative bg-slate-50 dark:bg-black transition-colors duration-500 border-b border-t border-slate-200 dark:border-white/5 z-20">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 dark:opacity-[0.02] mix-blend-overlay pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 tracking-wide max-w-7xl mx-auto">
          {stats.map((stat, idx) => (
            <div key={idx} className="bg-white/70 dark:bg-zinc-900/40 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-3xl p-8 hover:-translate-y-2 transition-all duration-500 group relative overflow-hidden shadow-sm hover:shadow-xl dark:shadow-[0_10px_30px_rgba(0,0,0,0.3)] hover:border-primary-500/30 dark:hover:border-primary-500/50 flex flex-col pt-10">

              <div className="absolute top-0 right-0 w-32 h-32 bg-primary-500/5 dark:bg-primary-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-700 ease-out blur-[20px] pointer-events-none"></div>

              <div className="w-16 h-16 rounded-2xl bg-slate-50 dark:bg-zinc-800/80 border border-slate-200 dark:border-white/10 flex items-center justify-center mb-6 relative group-hover:scale-110 transition-transform duration-500 z-10 shadow-sm dark:shadow-none">
                {/* Internal glow behind icon */}
                <div className="absolute inset-0 bg-primary-500/30 dark:bg-primary-500/40 blur-[12px] rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="relative z-10">
                  {stat.icon}
                </div>
              </div>

              <h3 className="text-2xl font-extrabold text-slate-900 dark:text-white mb-3 transition-colors duration-500 relative z-10 leading-tight">{stat.title}</h3>
              <p className="text-xl md:text-xl text-slate-600 dark:text-zinc-400 font-medium leading-relaxed transition-colors duration-500 relative z-10">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
